
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class FeatureOn extends Vue {
  @Prop({ required: true }) isOn!: boolean;
}
